import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Interface para tipado
 */
export interface SeguimientosPrograma {
  id?: number;
  id_programa: number;
  responsable: number;
  avance: number;
  resultado: number;
  observaciones: string;
  estado?: number; 
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

@Injectable({
  providedIn: "root",
})
export class SeguimientosProgramaService {
  private apiUrl = `${environment.apiUrl}/api/seguimientos-programa`;

  constructor(private http: HttpClient) {}

  // Listar todos
  getSeguimientos(): Observable<SeguimientosPrograma[]> {
    return this.http
      .get<SeguimientosPrograma[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Obtener por ID
  getSeguimientoById(idPrograma: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${idPrograma}`, { withCredentials: true })
    .pipe(catchError((error) => throwError(() => error)));
  }

  // Crear
  createSeguimiento(payload: SeguimientosPrograma): Observable<SeguimientosPrograma> {
    return this.http
      .post<SeguimientosPrograma>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Actualizar
  updateSeguimiento(id: number | string, payload: SeguimientosPrograma): Observable<SeguimientosPrograma> {
    return this.http
      .put<SeguimientosPrograma>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Eliminar
  deleteSeguimiento(id: number | string): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Activar
  activar(id: number | string): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  // Inactivar
  inactivar(id: number | string): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getSeguimientosProgramaByProgramaId(idPrograma: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/programa/${idPrograma}`, { withCredentials: true })
    .pipe(catchError((error) => throwError(() => error)));
  }
}
